export default (value = '', character = '<br>') => value.replace(/\n/g, character);



// WEBPACK FOOTER //
// ./sources/filters/linebreak.js